import React from 'react';
import { DownloadCard } from 'src/components/enterprise/features/Employee/EmployeeListPage/components/AddEmployeesDialog/DownloadCard';
import { useDownloadCsvTemplate } from 'src/components/enterprise/features/Employee/EmployeeUploadPage/components/DownloadCsvTemplate/hooks/useDownloadCsvTemplate';

export function DownloadCsvTemplate(): JSX.Element {
  const { downloadCsvTemplate, isDownloading } = useDownloadCsvTemplate();

  const handleDownload = (): void => {
    downloadCsvTemplate();
  };

  return (
    <DownloadCard
      title="First time uploading?"
      description="Use this CSV template as a guide, edit it to add your employees, then upload it below."
      actionLabel="Download template"
      onClick={handleDownload}
      isDisabled={isDownloading}
      isLoading={isDownloading}
    />
  );
}
